// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"6":"fe3fafec","155":"c2546e90","318":"d88ed916"}[chunkId] || chunkId) + "-" + {"6":"f41d87d83125e20e","44":"2cd860f29d1d900c","155":"ecac529ea9bc12ca","318":"f12e796e50634da5","907":"9b77c3721ef86c4c"}[chunkId] + ".js";
};